/**
 * Initiales d'un utilisateur pour son avatar : première lettre du prénom et du
 * nom, en capitales. Sans nom, la première lettre du pseudo (apprenant sans
 * e-mail, #271) ; à défaut « U », pour que l'avatar ne soit jamais vide.
 */
export function userInitials(firstName?: string | null, lastName?: string | null, username?: string | null): string {
  const initials = [firstName, lastName]
    .map(name => name?.trim().charAt(0) ?? '')
    .join('')
    .toUpperCase()
  return initials || username?.trim().charAt(0).toUpperCase() || 'U'
}
